import RadioItemList, { RadioItemListProps } from './RadioItemList';

export type { RadioItemListProps };
export default RadioItemList;
